export enum USER_REMINDER {
    NONE = 'none',
    BEFORE2HOUR = '2h',
    BEFORE1DAY = '1d',
    BEFORE3DAYS = '3d',
    BEFORE1HOUR = '1h',
    BEFORE24HOURS = '24h',
    BEFORE1WEEK = '1w',
}

export enum CONTACT_REMINDER {
    BEFORE1DAY = '1d',
    BEFORE3DAYS = '3d',
    BEFORE1WEEK = '1w',
}

export enum CUSTOM_REMINDER {
    MINUTES_BEFORE = 'm',
    HOURS_BEFORE = 'h',
    DAYS_BEFORE = 'd',
    WEEKS_BEFORE = 'w',
}

export const CUSTOM_REMINDER_VALUES_MAP = {
    [CUSTOM_REMINDER.MINUTES_BEFORE]: 'ShowEvent:alert:minutes_before',
    [CUSTOM_REMINDER.HOURS_BEFORE]: 'ShowEvent:alert:hours_before',
    [CUSTOM_REMINDER.DAYS_BEFORE]: 'ShowEvent:alert:days_before',
    [CUSTOM_REMINDER.WEEKS_BEFORE]: 'ShowEvent:alert:weeks_before',
};

export const USER_REMINDER_VALUES_MAP = {
    [USER_REMINDER.NONE]: 'ShowEvent:alert:no_alert',
    [USER_REMINDER.BEFORE1HOUR]: 'ShowEvent:alert:1h',
    [USER_REMINDER.BEFORE24HOURS]: 'ShowEvent:alert:24h',
    [USER_REMINDER.BEFORE1WEEK]: 'ShowEvent:alert:1w',
};

export const USER_REMINDER_LABELS = [
    USER_REMINDER.NONE,
    USER_REMINDER.BEFORE1HOUR,
    USER_REMINDER.BEFORE24HOURS,
    USER_REMINDER.BEFORE1WEEK,
];

export const CONTACT_REMINDER_LABELS = [
    USER_REMINDER.BEFORE1HOUR,
    USER_REMINDER.BEFORE24HOURS,
    USER_REMINDER.BEFORE1WEEK,
];

export enum INVITATIONS {
    NONE = 'none',
    CONTACTS = 'contacts',
    OWNERS = 'owners',
    CONTACTS_AND_OWNERS = 'contacts_and_owners',
}

export const INVITATIONS_MAP = {
    [INVITATIONS.NONE]: 'ShowEvent:alert:do_not_notify',
    [INVITATIONS.CONTACTS]: 'ShowEvent:alert:contacts_notified',
    [INVITATIONS.OWNERS]: 'ShowEvent:alert:owners_notified',
    [INVITATIONS.CONTACTS_AND_OWNERS]:
        'ShowEvent:alert:contacts_owners_notified',
};
